import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import styles from "./Title.module.css";
import classNames from "classnames";
import { useState } from "react";
import menu_icon from "../image/menu_icon.svg";
import LanguageDropDown from "./LanguageDropDown";
import default_league from "../global/defaultLeague.json"

const serviceList = [
  ["Home", ""],
  ["Rank prediction", "rank_prediction"],
  ["Match Prediction", "match_prediction"],
	["Simulation", "simulation"],
  //["Articles", "articles"],
];

function Title({ service, language }) {
  const [showUnderBar, setShowUnderBar] = useState(false);
  return (
    <header className={styles.header}>
      <div className={styles.container}>
        <h1>
          <Link className={styles.title_link} to={`/${language}`}>
            League ELO
          </Link>
        </h1>
        <nav className={styles.navigator}>
          {serviceList.map((pair) =>
            pair[1] === service ? (
              <div key={pair[1]}>
                <h2
                  className={classNames(styles.title_content, styles.current)}
                >
                  {pair[0]}
                </h2>
              </div>
            ) : (
              <div key={pair[1]}>
                <h2 className={styles.title_content}>
                  <Link
                    className={styles.title_link}
                    to={
                      pair[1] === ""
                        ? `/${language}`
                        : pair[1] === "simulation"
                        ? `/${language}/${pair[1]}`
                        : `/${language}/${pair[1]}/${default_league}`
                    }
                  >
                    {pair[0]}
                  </Link>
                </h2>
              </div>
            )
          )}
          <div key="mobile_language_dropdown" className={styles.title_content}>
            <LanguageDropDown />
          </div>
        </nav>
        <button
          className={styles.menu_button}
          onClick={() => {
            setShowUnderBar((cur) => !cur);
          }}
        >
          <img src={menu_icon} alt={language === "kr" ? "메뉴" : "menu"} />
        </button>
      </div>
      <nav
        className={classNames([
          styles.under_bar,
          showUnderBar ? styles.show_under_bar : null,
        ])}
      >
        {serviceList.map((pair) =>
          pair[0] === service ? (
            <div key={pair[1]} className={styles.under_box}>
              <strong
                className={classNames([styles.under_content, styles.current])}
              >
                {pair[0]}
              </strong>
            </div>
          ) : (
            <div key={pair[1]} className={styles.under_box}>
              <Link
                className={styles.under_content}
                to={
                      pair[1] === ""
                        ? `/${language}`
                        : pair[1] === "simulation"
                        ? `/${language}/${pair[1]}`
                        : `/${language}/${pair[1]}/${default_league}`
                }
              >
                {pair[0]}
              </Link>
            </div>
          )
        )}
        <div key="mobile_language_dropdown" className={styles.under_box}>
          <LanguageDropDown />
        </div>
      </nav>
    </header>
  );
}

Title.propTypes = {
  service: PropTypes.string.isRequired,
  language: PropTypes.string.isRequired,
};

export default Title;
